module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/cards/cards-style1/cards-style1.component.scss
// module id = ./src/app/features/cards/cards-style1/cards-style1.component.scss
// module chunks = main